import './Tabs.less'
import Tabs from './Tabs'
import Tab from './Tab'

export {
  Tabs, Tab
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Tabs/index.js